var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_7628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1663 36.6704C42.166 37.389 42.0242 38.1006 41.7489 38.7644C41.4736 39.4281 41.0702 40.0312 40.5618 40.5391C40.0534 41.047 39.45 41.4498 38.7859 41.7244C38.1218 41.9991 37.4102 42.1402 36.6916 42.1398H9.30855C7.85721 42.1405 6.46506 41.5646 5.43824 40.5389C4.41142 39.5132 3.83402 38.1217 3.83301 36.6704V9.32778C3.83422 7.87665 4.41174 6.48541 5.43856 5.46003C6.46538 4.43464 7.85742 3.85906 9.30855 3.85986H36.6916C37.4101 3.85936 38.1217 4.00041 38.7857 4.27493C39.4497 4.54946 40.0531 4.9521 40.5615 5.45985C41.0699 5.9676 41.4733 6.57052 41.7486 7.23419C42.024 7.89785 42.1659 8.60926 42.1663 9.32778V36.6704Z",
    fill: "#FFE400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2214 26.8292C31.0496 25.495 30.3825 24.274 29.3525 23.4086C29.2001 23.2744 29.0347 23.1494 28.8518 23.0008C29.0042 22.8865 29.1308 22.7988 29.2489 22.7005C29.9902 22.0869 30.5629 21.2944 30.9127 20.3979C31.2441 19.5502 31.3492 18.6309 31.2176 17.7303C31.0718 16.6348 30.5877 15.6121 29.8327 14.805C29.2947 14.2059 28.63 13.7341 27.8869 13.4239C27.1651 13.1317 26.3926 12.9854 25.614 12.9933H16.8885C16.8284 12.9899 16.7681 12.9899 16.7079 12.9933C16.6122 12.9977 16.522 13.0394 16.4568 13.1095C16.3915 13.1796 16.3563 13.2725 16.3588 13.3683C16.3588 13.4293 16.3588 13.4895 16.3588 13.5497V32.4023C16.3588 32.4969 16.3535 32.5921 16.3588 32.6866C16.3627 32.7648 16.3938 32.839 16.4467 32.8967C16.4996 32.9543 16.5709 32.9916 16.6484 33.0022C16.7084 33.0094 16.7688 33.0117 16.8291 33.009H25.8655C26.7756 33.0126 27.6701 32.7734 28.457 32.3162C29.5812 31.6845 30.4489 30.6792 30.9097 29.4748C31.2423 28.6352 31.3498 27.7232 31.2214 26.8292ZM24.2772 27.5076H22.6468V18.5138H24.2589C24.2589 18.5138 24.2528 18.5092 24.2589 18.5092V18.5138H24.2772V27.5076Z",
    fill: "#1E1719"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_7628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.3333,
    height: 38.2807,
    fill: "white",
    transform: "translate(3.83301 3.85986)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/카카오뱅크-46.bc3b25635e52e79f0e66ac198ed5265c.svg";
export { ForwardRef as ReactComponent };